import { GovGrid } from '@gov-design-system-ce/react';
import type { PageCode, SearchAllTypesResult } from '@gov-nx/module/page';
import { SearchResultsGridItem } from './SearchResultGridItem';

interface SearchResultsGridProps {
	code: PageCode;
	items: SearchAllTypesResult[];
	onItemClick?: () => void;
}

export const SearchResultsGrid = ({
	code,
	items: results,
}: SearchResultsGridProps) => (
	<GovGrid gap="l">
		{results.map((item) => (
			<SearchResultsGridItem
				key={item.code + item.title}
				code={code}
				item={item}
			/>
		))}
	</GovGrid>
);
